import React from 'react';
import { useLocale } from '../contexts/LocaleContext';
import { useTranslation } from 'react-i18next';
import { Languages } from 'lucide-react';

export const LanguageSwitcher: React.FC = () => {
  const { locale, setLocale, availableLocales } = useLocale();
  const { t } = useTranslation('common');

  const options = availableLocales.map((lang) => (
    <option key={lang.code} value={lang.code}>
      {lang.name}
    </option>
  ));

  return (
    <>
      <div className="relative inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-md border border-gray-300 dark:border-gray-600 sm:hidden">
        <Languages className="h-4 w-4 text-gray-500 dark:text-gray-400" aria-hidden="true" />
        <select
          value={locale}
          onChange={(e) => setLocale(e.target.value as 'en' | 'es')}
          className="absolute inset-0 h-full w-full cursor-pointer opacity-0"
          aria-label={t('language.select')}
        >
          {options}
        </select>
      </div>
      <div className="relative hidden shrink-0 sm:inline-block">
        <select
          value={locale}
          onChange={(e) => setLocale(e.target.value as 'en' | 'es')}
          className="appearance-none bg-transparent border border-gray-300 dark:border-gray-600 rounded-md px-3 py-2 pr-8 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 dark:text-gray-200 cursor-pointer"
          aria-label={t('language.select')}
        >
          {options}
        </select>
        <Languages className="pointer-events-none absolute right-2 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-500 dark:text-gray-400" />
      </div>
    </>
  );
};
